webpackJsonp([1],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(828),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1fe02d51",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      switchToggle: true
    };
  }
});

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".upload-screen-1-container[data-v-1fe02d51]{height:100vh;width:100%;padding:25px}.upload-screen-1-container .hr-text[data-v-1fe02d51]{line-height:1em;position:relative;outline:0;border:0;color:#000;text-align:center;height:1.5em;opacity:.5}.upload-screen-1-container .hr-text[data-v-1fe02d51]:before{content:\"\";background:#818078;position:absolute;left:0;top:50%;width:100%;height:1px}.upload-screen-1-container .hr-text[data-v-1fe02d51]:after{margin-top:-6px;font-size:24px;-webkit-font-feature-settings:\"liga\";position:relative;margin-left:-100%;display:inline-block;font-family:Material Icons;content:\"keyboard_backspace\";-webkit-font-feature-settings:\"liga\" 1;font-feature-settings:\"liga\" 1;padding:0 .5em;line-height:1.5em;color:#818078;background-color:#fcfcfa}.upload-screen-1-container .input-container[data-v-1fe02d51]{margin-bottom:15px;width:100%;position:relative}.upload-screen-1-container .input-container .public-access-toggle[data-v-1fe02d51]{top:0;right:20px;position:absolute}.upload-screen-1-container .input-container .location-icon[data-v-1fe02d51]{top:40%;right:20px;position:absolute}.upload-screen-1-container .input-container .input-label[data-v-1fe02d51]{text-align:left;font-size:1.286em;font-weight:700}.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51]{width:100%;height:100%;outline:none}.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] ::-webkit-input-placeholder{font-size:1em}.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] :-ms-input-placeholder,.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] ::-ms-input-placeholder{font-size:1em}.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] ::placeholder{font-size:1em}.upload-screen-1-container .input-container .input-container-text[data-v-1fe02d51]{font-size:.857em;text-align:left;margin-right:35px}.upload-screen-1-container .important-details-container[data-v-1fe02d51]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;position:relative}.upload-screen-1-container .important-details-container .back-icon[data-v-1fe02d51]{position:absolute;left:0;top:58%}.upload-screen-1-container .important-details-container .important-details[data-v-1fe02d51]{width:98%;text-align:right;font-size:1.286em;font-weight:700}.upload-screen-1-container .important-details-container .hr-div[data-v-1fe02d51]{margin-left:20px;position:absolute;width:90%;top:58%;left:20px;background:#d3d3d3;height:1px}.upload-screen-1-container .img-and-caption-container[data-v-1fe02d51]{border-bottom:1px solid #d3d3d3;margin:19px 0 9px}.upload-screen-1-container .img-and-caption-container .img-container img[data-v-1fe02d51]{width:6.429em;height:4.286em;-o-object-fit:cover;object-fit:cover}.upload-screen-1-container .img-and-caption-container .caption-container[data-v-1fe02d51]{padding-left:10px;text-align:left}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51]{width:100%;height:100%;outline:none;resize:none}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] ::-webkit-input-placeholder{font-size:1em}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] :-ms-input-placeholder,.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] ::-ms-input-placeholder{font-size:1em}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] ::placeholder{font-size:1em}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/uploadScreens/uploadScreen-1.vue"],"names":[],"mappings":"AACA,4CACE,aAAc,AACd,WAAY,AACZ,YAAc,CACf,AACD,qDACI,gBAAiB,AACjB,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,WAAa,AACb,kBAAmB,AACnB,aAAc,AACd,UAAY,CACf,AACD,4DACM,WAAY,AACZ,mBAAoB,AACpB,kBAAmB,AACnB,OAAQ,AACR,QAAS,AACT,WAAY,AACZ,UAAY,CACjB,AACD,2DACM,gBAAiB,AACjB,eAAgB,AAChB,qCAAsC,AACtC,kBAAmB,AACnB,kBAAmB,AACnB,qBAAsB,AACtB,2BAA8B,AAC9B,6BAA8B,AAC9B,uCAAwC,AACxC,+BAAgC,AAChC,eAAgB,AAChB,kBAAmB,AACnB,cAAe,AACf,wBAA0B,CAC/B,AACD,6DACI,mBAAoB,AACpB,WAAY,AACZ,iBAAmB,CACtB,AACD,mFACM,MAAO,AACP,WAAY,AACZ,iBAAmB,CACxB,AACD,4EACM,QAAS,AACT,WAAY,AACZ,iBAAmB,CACxB,AACD,0EACM,gBAAiB,AACjB,kBAAmB,AACnB,eAAiB,CACtB,AACD,6EACM,WAAY,AACZ,YAAa,AACb,YAAc,CACnB,AACD,yGACQ,aAAe,CACtB,AAID,yMACQ,aAAe,CACtB,AACD,2FACQ,aAAe,CACtB,AACD,mFACM,iBAAmB,AACnB,gBAAiB,AACjB,iBAAmB,CACxB,AACD,yEACI,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,iBAAmB,CACtB,AACD,oFACM,kBAAmB,AACnB,OAAQ,AACR,OAAS,CACd,AACD,4FACM,UAAW,AACX,iBAAkB,AAClB,kBAAmB,AACnB,eAAiB,CACtB,AACD,iFACM,iBAAkB,AAClB,kBAAmB,AACnB,UAAW,AACX,QAAS,AACT,UAAW,AACX,mBAAsB,AACtB,UAAY,CACjB,AACD,uEACI,gCAAmC,AACnC,iBAAqB,CACxB,AACD,0FACM,cAAe,AACf,eAAgB,AAChB,oBAAqB,AAClB,gBAAkB,CAC1B,AACD,0FACM,kBAAmB,AACnB,eAAiB,CACtB,AACD,6GACQ,WAAY,AACZ,YAAa,AACb,aAAc,AACd,WAAa,CACpB,AACD,yIACU,aAAe,CACxB,AAID,yQACU,aAAe,CACxB,AACD,2HACU,aAAe,CACxB","file":"uploadScreen-1.vue","sourcesContent":["\n.upload-screen-1-container[data-v-1fe02d51] {\n  height: 100vh;\n  width: 100%;\n  padding: 25px;\n}\n.upload-screen-1-container .hr-text[data-v-1fe02d51] {\n    line-height: 1em;\n    position: relative;\n    outline: 0;\n    border: 0;\n    color: black;\n    text-align: center;\n    height: 1.5em;\n    opacity: .5;\n}\n.upload-screen-1-container .hr-text[data-v-1fe02d51]:before {\n      content: '';\n      background: #818078;\n      position: absolute;\n      left: 0;\n      top: 50%;\n      width: 100%;\n      height: 1px;\n}\n.upload-screen-1-container .hr-text[data-v-1fe02d51]:after {\n      margin-top: -6px;\n      font-size: 24px;\n      -webkit-font-feature-settings: 'liga';\n      position: relative;\n      margin-left: -100%;\n      display: inline-block;\n      font-family: 'Material Icons';\n      content: \"keyboard_backspace\";\n      -webkit-font-feature-settings: 'liga' 1;\n      font-feature-settings: 'liga' 1;\n      padding: 0 .5em;\n      line-height: 1.5em;\n      color: #818078;\n      background-color: #fcfcfa;\n}\n.upload-screen-1-container .input-container[data-v-1fe02d51] {\n    margin-bottom: 15px;\n    width: 100%;\n    position: relative;\n}\n.upload-screen-1-container .input-container .public-access-toggle[data-v-1fe02d51] {\n      top: 0;\n      right: 20px;\n      position: absolute;\n}\n.upload-screen-1-container .input-container .location-icon[data-v-1fe02d51] {\n      top: 40%;\n      right: 20px;\n      position: absolute;\n}\n.upload-screen-1-container .input-container .input-label[data-v-1fe02d51] {\n      text-align: left;\n      font-size: 1.286em;\n      font-weight: 700;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] {\n      width: 100%;\n      height: 100%;\n      outline: none;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] ::-webkit-input-placeholder {\n        font-size: 1em;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] :-ms-input-placeholder {\n        font-size: 1em;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] ::-ms-input-placeholder {\n        font-size: 1em;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-1fe02d51] ::placeholder {\n        font-size: 1em;\n}\n.upload-screen-1-container .input-container .input-container-text[data-v-1fe02d51] {\n      font-size: 0.857em;\n      text-align: left;\n      margin-right: 35px;\n}\n.upload-screen-1-container .important-details-container[data-v-1fe02d51] {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    position: relative;\n}\n.upload-screen-1-container .important-details-container .back-icon[data-v-1fe02d51] {\n      position: absolute;\n      left: 0;\n      top: 58%;\n}\n.upload-screen-1-container .important-details-container .important-details[data-v-1fe02d51] {\n      width: 98%;\n      text-align: right;\n      font-size: 1.286em;\n      font-weight: 700;\n}\n.upload-screen-1-container .important-details-container .hr-div[data-v-1fe02d51] {\n      margin-left: 20px;\n      position: absolute;\n      width: 90%;\n      top: 58%;\n      left: 20px;\n      background: lightgrey;\n      height: 1px;\n}\n.upload-screen-1-container .img-and-caption-container[data-v-1fe02d51] {\n    border-bottom: 1px solid lightgrey;\n    margin: 19px 0 9px 0;\n}\n.upload-screen-1-container .img-and-caption-container .img-container img[data-v-1fe02d51] {\n      width: 6.429em;\n      height: 4.286em;\n      -o-object-fit: cover;\n         object-fit: cover;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container[data-v-1fe02d51] {\n      padding-left: 10px;\n      text-align: left;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] {\n        width: 100%;\n        height: 100%;\n        outline: none;\n        resize: none;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] ::-webkit-input-placeholder {\n          font-size: 1em;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] :-ms-input-placeholder {\n          font-size: 1em;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] ::-ms-input-placeholder {\n          font-size: 1em;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-1fe02d51] ::placeholder {\n          font-size: 1em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(661);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("4d3687a6", content, true, {});

/***/ }),

/***/ 828:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white upload-screen-1-container"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticClass: "hr-text"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "img-and-caption-container",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "img-container",
    attrs: {
      "xs4": "",
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/viewzzz/image/upload/w_auto/v1523306017/dpfvh28om5ef75hlbdtc.jpg"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption-container",
    attrs: {
      "xs8": "",
      "md11": ""
    }
  }, [_c('textarea', {
    staticClass: "caption-text-area",
    attrs: {
      "placeholder": "Write a caption…"
    }
  })])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('v-icon', {
    staticClass: "location-icon blue--text"
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('div', {
    staticClass: "input-label text-xs-left "
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "input-container-text"
  }, [_vm._v("\n      ISB, Gachibowli, Hyderabad, Telangana 500032, India\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "public-access-toggle blue--text"
  }, [_c('v-switch', {
    model: {
      value: (_vm.switchToggle),
      callback: function($$v) {
        _vm.switchToggle = $$v
      },
      expression: "switchToggle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("Public access")]), _vm._v(" "), _c('div', {
    staticClass: "input-container-text"
  }, [_vm._v("\n      Please UNSELECT, if photo was taken from a private property and it is not allowed for everyone to visit this spot.\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "important-details-container"
  }, [_c('div', {
    staticClass: "important-details"
  }, [_vm._v("Important details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("Describe emotional appeal")]), _vm._v(" "), _c('input', {
    staticClass: "img-desc-input",
    attrs: {
      "placeholder": "romantic, relaxing, energetic, weird…"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("Photo was taken from")]), _vm._v(" "), _c('input', {
    staticClass: "img-desc-input",
    attrs: {
      "placeholder": "street, bar, hotel room, 4th floor…"
    }
  })])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/1.39da94c623fc215e0765.js